"use client";
import { PiArrowLeft, PiArrowRight, PiMagicWand } from "react-icons/pi";
import { Universe, UniverseSelect } from "./UniverseSelect";
import { OverrideUser } from "./OverrideUser";
import { useEffect, useState } from "react";
import Link from "next/link";
import { getCookie } from "@cappelendamm/cookie";
import {
  COOKIE_INTERNAL_USER_OR_BOT,
  INTERNAL_USER_DETECTION,
} from "@/routing";

export const ToolBarSlider = ({ universes }: { universes: Universe[] }) => {
  const [{ isOpen, isVisible }, setState] = useState<{
    isOpen: boolean;
    isVisible: boolean;
  }>({ isOpen: false, isVisible: false });
  useEffect(() => {
    const botCookie = getCookie(COOKIE_INTERNAL_USER_OR_BOT);
    const isBot = [
      ...INTERNAL_USER_DETECTION.HEADERS,
      ...INTERNAL_USER_DETECTION.BOTS,
    ].includes(botCookie);
    setState((prev) => ({ ...prev, isVisible: !isBot }));
  }, []);
  if (!isVisible) return null;
  return (
    <div className="fixed right-0 bottom-4 z-50">
      <div className="grid grid-flow-col items-center gap-2 rounded-l-full bg-status-warning-500 p-2 text-black">
        <button
          onClick={() =>
            setState((prev) => ({ ...prev, isOpen: !prev.isOpen }))
          }
          className="flex h-8 w-8 items-center justify-center rounded-full bg-white/75"
        >
          {isOpen ? <PiArrowRight size={24} /> : <PiArrowLeft size={24} />}
        </button>
        {isOpen && (
          <>
            <UniverseSelect universes={universes} />
            <Link href="/admin" title="Admin page">
              <PiMagicWand
                className="rounded-full p-1 hover:bg-white/75"
                size={32}
              />
            </Link>
            <OverrideUser />
          </>
        )}
      </div>
    </div>
  );
};
